import styled from 'styled-components/macro';

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
`;

export const Header = styled.div`
  padding: 20px 24px;
  background-color: #ffffff;
  border-bottom: 1px solid #e0e0e0;
`;

export const LoadingContainer = styled.div`
  padding: 24px;
  background-color: #ffffff;
`;

export const ErrorContainer = styled.div`
  padding: 24px;
  background-color: #ffffff;
`;

export const DashboardContainer = styled.div<{ isVisible: boolean }>`
  flex: 1;
  width: 100%;
  background-color: #f8f9fa;
  display: ${({ isVisible }) => (isVisible ? 'block' : 'none')};
`;

export const PlaceholderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #666;
`;
